<template>
  <div class="data-content" v-if="item.format === 9">
    <div class="data-value" style="display: none" v-html="convertMessage(item.format, value)" />
    <GoogleMap
      ref="mapRef"
      api-key="AIzaSyD-8DTPaULa6abepETtf3F0WnoJG2Wg-nE"
      mapId="b272aa3d04263d4a"
      class="map"
      :center="center"
      :zoom="20"
      :panControl="true"
    >
      <CustomMarker :options="{ position: center, anchorPoint: 'BOTTOM_CENTER' }">
        <div style="text-align: center">
          <img :src="logoSrc" alt="User Image" class="logo-image" style="width: 40px; height: auto;" />
        </div>
      </CustomMarker>
    </GoogleMap>
  </div>
  <div class="data-content-slave" v-else-if="item.format === 8">
    <div class="data-value">{{ item.name }}:</div>
    <SlaveDataItem v-for="number in count" :key="number" :index="number" :item="item" />
  </div>
  <div class="data-content" v-else>
    <div class="data-value">{{ item.name }}:</div>
    <div class="data-value" v-if="value" v-html="convertMessage(item.format, value)" />
    <div class="data-value" v-else>NULL</div>
    <div class="data-value">{{ item.unit }}</div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import {
  ref, inject, reactive, watch, onMounted,
} from 'vue';
import { $mqtt } from 'vue-paho-mqtt';
import { GoogleMap, CustomMarker } from 'vue3-google-map';
import logoIcon from '@/assets/logo.png';
import { checkPages } from '../utils/stringValid';
import { fetchList } from '../utils/api';
import SlaveDataItem from './SlaveDataItem.vue';

export default {
  components: {
    GoogleMap,
    CustomMarker,
    SlaveDataItem,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logoSrc: logoIcon,
    };
  },
  setup(props) {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'project';
    const table = ref([]);
    const value = ref('');
    const count = ref(0);
    const mapRef = ref(null);
    const markerRef = ref(null);

    const center = reactive({ lat: 23.974674410356304, lng: 120.97947004006947 });
    const markerOptions = reactive({ position: center });
    const data = JSON.stringify({
      sid: props.item.sub_id,
    });
    onMounted(() => {
      if (props.item.mac > 0 && props.item.topic) {
        const topic = props.item.topic.replace('{MAC}', `${props.item.mac}`);
        if (props.item.format === 7) {
          fetchList(t, `${apiBaseUrl}/list/format_table`, data).then((response) => {
            table.value = response.data.result.map((item) => ({
              label: item.source,
              value: item.target,
            }));
            $mqtt.subscribe(
              topic,
              (message) => {
                value.value = message;
              },
              false,
            );
          });
        } else {
          $mqtt.subscribe(
            topic,
            (message) => {
              value.value = message;
              if (props.item.format === 8) {
                count.value = Math.floor((parseInt(message, 10) + 1) / 2);
                count.value = 4;
              }
            },
            false,
          );
        }
      }
    });

    watch([() => mapRef.value?.ready, center], ([ready, pos]) => {
      if (!ready) return;
      mapRef.value.map.panTo(pos);
    });
    return {
      t,
      apiBaseUrl,
      url,
      table,
      value,
      count,
      center,
      markerOptions,
      mapRef,
      markerRef,
    };
  },
  methods: {
    checkPages,
    convertMessage(format, value) {
      switch (format) {
        case 2: {
          let charge = '';
          let battery = Math.abs(value);
          if (battery > 100) battery = 100;
          if (value < 0) charge = '(充電中)';
          return `${charge}${battery}`;
        }
        case 5: {
          const part1 = (value >> 24) & 0xff;
          const part2 = (value >> 16) & 0xff;
          const part3 = (value >> 8) & 0xff;
          const part4 = value & 0xff;
          return `${part4}.${part3}.${part2}.${part1}`;
        }
        case 6: {
          const parts = value.split(':');
          if (parts.length === 3) {
            return `${this.t('latitude')}: ${parts[0]}<br>${this.t('longitude')}:${parts[1]}`;
          }
        }
          break;
        case 9: {
          const parts = value.split(':');
          if (parts.length === 3) {
            this.center.lat = parseFloat(parts[0]);
            this.center.lng = parseFloat(parts[1]);
            return `${this.t('latitude')}: ${parts[0]}<br>${this.t('longitude')}:${parts[1]}`;
          }
        }
          break;
        case 7: {
          const target = this.table.find((item) => item.label === value);
          return target ? target.value : value;
        }
        default:
          break;
      }
      return value;
    },
  },
};
</script>

<style>
.data-content {
  width: 100%;
  display: flex;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding-left: 5px;
}
.data-content-slave {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 5px;
  grid-auto-rows: minmax(min-content, max-content);
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 5px;
}
.data-value {
  width: auto;
  padding-right: 5px;
}
.grey-circle {
  width: 10px;
  height: 10px;
  background-color: gray;
  border-radius: 50%;
  margin-top: 8px;
}
.red-circle {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-top: 8px;
}
.green-circle {
  width: 10px;
  height: 10px;
  background-color: rgb(71, 255, 71);
  border-radius: 50%;
  margin-top: 8px;
}
.map {
  position: relative;
  width: 100%;
  height: 300px;
}
@media (max-width: 600px) {
  .data-item {
    flex-direction: column;
    align-items: start;
  }
}
</style>
